export default __webpack_public_path__ + "static/media/NIAS0320.34I-43082_-25739_0.3818d6fc.jpg";